import React, { Component } from 'react';

import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import { Text } from 'common-components/typography';
import { Icon } from 'antd';
import ActionSelectItem from 'common-components/items/ActionSelectItem';
import { PaymentPermissionType, PermissionType } from 'utilities/enum-utils';
import { getPaymentPermissionName } from 'views/account-management/utils/permission-utils';

interface ICreateServiceDepartmentModalProps {
  isOpen: any;
  onClose: any;
  setSelectedOption: (servicePermission) => any;
  permissions?: any;
}

interface ICreateServiceDepartmentModalState {
  paymentPermission: string;
}

class PaymentsSectionModal extends Component<ICreateServiceDepartmentModalProps, ICreateServiceDepartmentModalState> {
  state = { paymentPermission: PaymentPermissionType.NO_ACCESS };

  private _onCloseModal = () => {
    this.props.onClose();
  };

  private _setSelectedOption = async () => {
    await this.props.setSelectedOption({ paymentPermission: this.state.paymentPermission });
    this._onCloseModal();
  };

  private _changePermissionMode = (newMode) => {
    this.setState({ paymentPermission: newMode });
  };

  resetPermissions = () => {
    const paymentPermission = getPaymentPermissionName(this.props.permissions);
    this.setState({ paymentPermission });
  };

  componentDidMount() {
    this.resetPermissions();
  }

  componentDidUpdate(
    prevProps: Readonly<ICreateServiceDepartmentModalProps>,
    prevState: Readonly<ICreateServiceDepartmentModalState>,
    snapshot?: any,
  ) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        this.resetPermissions();
      }
    }
  }

  render() {
    const { paymentPermission } = this.state;

    return (
      <ActionModal
        title={
          <>
            <Icon type={'bank'} className={'mr-small text-size-x2-large'} />
            Payment section
          </>
        }
        isOpen={this.props.isOpen}
        onClose={this._onCloseModal}
        width="medium"
      >
        <div className="mv-medium anim-slide-left">
          <div className={'mb-x-large'}>
            <div className={'mb-large'}>
              <Text size={'x-large'}>General permissions</Text>
            </div>

            <ActionSelectItem
              selectedAction={paymentPermission}
              value={PaymentPermissionType.NO_ACCESS}
              title={'No access (default)'}
              description={'Cannot see or access this section'}
              onSetAction={this._changePermissionMode}
            />

            <ActionSelectItem
              selectedAction={paymentPermission}
              value={PaymentPermissionType.MEMBER}
              title={'Member'}
              description={'Can see and perform basic actions within this section'}
              onSetAction={this._changePermissionMode}
            />

            <ActionSelectItem
              selectedAction={paymentPermission}
              value={PaymentPermissionType.MANAGER}
              title={'Manager'}
              description={'Can see and perform all actions within this section'}
              onSetAction={this._changePermissionMode}
            />
          </div>

          <ActionModalFooter>
            <SecondaryButton size="large" className="mr-medium" onClick={this._onCloseModal}>
              Cancel
            </SecondaryButton>
            <PrimaryButton size="large" onClick={this._setSelectedOption}>
              Save changes
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      </ActionModal>
    );
  }
}

export default PaymentsSectionModal;
